module.exports = __webpack_public_path__ + "static/media/vector2-1.c4b4f830.svg";